/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import { Link } from 'react-router-dom';

class InstagramBusinessOptions extends React.Component {
    render() {
        let currentPanel = null,
            visibleSettings = null,
            constants = this.props.app.config.constants,
            postTitle = !!(parseInt(this.props.getParamValue('postTitle'), 10)),
            postBody = !!(parseInt(this.props.getParamValue('postBody'), 10)),
            postUrl = !!(parseInt(this.props.getParamValue('postUrl'), 10)),
            postQrCode = !!(parseInt(this.props.getParamValue('postQrCode'), 10)),
            prefixSpace = !!(parseInt(this.props.getParamValue('prefixSpace'), 10)),
            postfixSpace = !!(parseInt(this.props.getParamValue('postfixSpace'), 10)),
            allowCropping = (parseInt(this.props.getParamValue('allowCropping'), 10)) ? true : false,
            inputSourceChooser = null;

        if (this.props.activePanel !== 'advanced') {
            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {this.props.getPostTitle(postTitle)}
                            {this.props.getPostBody(postBody)}
                            {this.props.getPostUrl(postUrl)}
                        </div>
                    )
                }
                if (this.props.fieldMapping.match("output") &&
                    this.props.hasInputOverrides &&
                    this.props.socialOverrides !== undefined &&
                    this.props.socialOverrides &&
                    this.props.socialOverrides.postStyle !== undefined &&
                    this.props.socialOverrides.postStyle !== constants.SOC_OVRD_STYLE_LINK) {
                    inputSourceChooser = this.props.getInputSourceFields();
                }

            } else {
                visibleSettings = (
                    <div>
                        {this.props.getPostTitle(postTitle)}
                        {this.props.getPostBody(postBody)}
                        {this.props.getPostUrl(postUrl)}
                    </div>
                );
            }

            /*
             * Instagram never posts a card of its own, since every post has an image, so unlike
             * TwitterOptions there is no card theme to offer beside this.
             */
            let qrCodeSetting = (
                <fieldset>
                    <legend>Add a QR Code for the Link<HelpButton {...this.props} which="postQrCodeInstagram"/>{this.props.getParamStateLabel('postQrCode')}</legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={this.props.errorMapping + ".postQrCode"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={postQrCode}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".postQrCode"}
                        controlState={this.props.getControlState()} />
                </fieldset>
            );

            currentPanel = (
                <div>
                    {visibleSettings}
                    {qrCodeSetting}
                    {inputSourceChooser}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    {this.props.getAllowCropping(allowCropping)}
                </div>
            )
        }

        return this.props.getPanelOutput(currentPanel);
    }

}

export default SocialPanelModule(InstagramBusinessOptions);
